module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-table', {
    staticClass: "selected-product-tab",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "tooltip-effect": "dark",
      "data": _vm.productLists,
      "empty-text": "还没有选择产品"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "logo",
      "header-align": "center",
      "align": "center",
      "width": "100px",
      "label": "产品图片"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "tpimg",
          attrs: {
            "src": scope.row.logo,
            "alt": scope.row.logo
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "产品名称",
      "min-width": "140",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "purchaseNum",
      "label": "购买数量",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;
        var $index = ref.$index;

        return [(!_vm.isEdit) ? _c('span', [_vm._v(_vm._s(row.purchaseNum))]) : _c('el-input-number', {
          attrs: {
            "min": 1,
            "size": "small",
            "step-strictly": true,
            "controls-position": "right"
          },
          on: {
            "change": function (val) { return _vm.handleChangeNum(val, row, 'purchaseNum'); }
          },
          model: {
            value: (row.purchaseNum),
            callback: function($$v) {
              _vm.$set(row, "purchaseNum", $$v)
            },
            expression: "row.purchaseNum"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "purchaseMonth",
      "label": "购买时长(月)",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;
        var $index = ref.$index;

        return [(!_vm.isEdit) ? _c('span', [_vm._v(_vm._s(row.purchaseMonth))]) : _c('el-input-number', {
          attrs: {
            "min": 1,
            "size": "small",
            "step-strictly": true,
            "controls-position": "right"
          },
          on: {
            "change": _vm.handleChangeNum
          },
          model: {
            value: (row.purchaseMonth),
            callback: function($$v) {
              _vm.$set(row, "purchaseMonth", $$v)
            },
            expression: "row.purchaseMonth"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "单价(元)",
      "min-width": "100",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "price"
        }, [_vm._v(_vm._s(scope.row.price.toLocaleString()))])]
      }
    }])
  }), _vm._v(" "), (!_vm.isEdit) ? _c('el-table-column', {
    attrs: {
      "prop": "effectivetime",
      "label": "启用时间",
      "min-width": "130",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.effectivetime || '-'))])]
      }
    }], null, false, 1536076627)
  }) : _vm._e(), _vm._v(" "), (!_vm.isEdit) ? _c('el-table-column', {
    attrs: {
      "prop": "duetime",
      "label": "到期时间",
      "min-width": "130",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.duetime || '-'))])]
      }
    }], null, false, 270402858)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    staticStyle: {
      "text-algin": "center"
    },
    attrs: {
      "label": "操作",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.isEdit) ? _c('span', {
          staticClass: "dnnfont icondelete",
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }) : _vm._e(), _vm._v(" "), (scope.row.renewFlg == 1) ? _c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": "续费",
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "dnnfont iconclock",
          on: {
            "click": function($event) {
              return _vm.handleRenewOrder(scope.$index, scope.row)
            }
          }
        })]) : _vm._e()]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18053269"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/administrator/orderList/SelectedProduct.vue
// module id = 1768
// module chunks = 9